var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarHeart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75806 1.63944C9.60291 1.31862 9.37918 1.0279 9.09942 0.783545C8.81945 0.538463 8.48936 0.3437 8.12709 0.209847C7.75144 0.0704978 7.34854 -0.000828799 6.94177 7.26568e-06C6.3711 7.26568e-06 5.81432 0.139556 5.33047 0.403147C5.21472 0.466202 5.10475 0.535459 5.00057 0.610919C4.89639 0.535459 4.78643 0.466202 4.67067 0.403147C4.18682 0.139556 3.63005 7.26568e-06 3.05938 7.26568e-06C2.64845 7.26568e-06 2.25026 0.0702983 1.87406 0.209847C1.51059 0.344226 1.18301 0.537527 0.901724 0.783545C0.621595 1.02762 0.397821 1.31841 0.243083 1.63944C0.0821853 1.97332 0 2.32788 0 2.69277C0 3.03699 0.0787128 3.39568 0.234981 3.76057C0.365783 4.06551 0.553304 4.38182 0.792915 4.70123C1.17259 5.20671 1.69464 5.73389 2.34286 6.26831C3.41706 7.15418 4.48084 7.76613 4.52598 7.79094L4.80032 7.94806C4.92186 8.01731 5.07813 8.01731 5.19967 7.94806L5.47401 7.79094C5.51915 7.76509 6.58177 7.15418 7.65713 6.26831C8.30535 5.73389 8.8274 5.20671 9.20707 4.70123C9.44668 4.38182 9.63536 4.06551 9.76501 3.76057C9.92128 3.39568 9.99999 3.03699 9.99999 2.69277C10.0011 2.32788 9.91896 1.97332 9.75806 1.63944Z",
    fill: "#028DFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarHeart);
export default __webpack_public_path__ + "static/media/avatar_heart.0c52f7444fd98892b993d1ee8252653b.svg";
export { ForwardRef as ReactComponent };